import MathUtils from './math';

/**
@function negatePhaseArray
@param phaseArray
@returns negatedPhaseArray
@description This function converts phaseArray points to negatives
*/
var negatePhase = function (phaseArray) {
  var negatedPhaseArray = [];

  for (var i = 0; i < phaseArray.length; i++) {
    negatedPhaseArray.push(phaseArray[i] * -1);
  }
  return negatedPhaseArray;
};

/**
@function hzToRadPerSecond(frequencyArray)
@param frequencyArray in Hz
@returns [frequency in rad/s]
@description takes a frequency array in HZ and converts to rad/s
*/
var hzToRadPerSecond = function (frequencyArray) {
  var result = [];

  for (var i = 0; i < frequencyArray.length; i++) {
    result.push(frequencyArray[i] * (2 * Math.PI));
  }

  return result;
};

/**
@function radianArrayToDegreeArray
@param  radian point
@returns degree point
@description  This function takes as a parameter as a radian and returns a degree point
*/
export function radianArrayToDegreeArray(radArray) {
  var result = radArray.map((item) => {
    return this.radianToDegree(item);
  });
  return result;
}

/**
@function radianToDegree
@param  radian point
@returns degree point
@description  This function takes as a parameter as a radian and returns a degree point
*/
export function radianToDegree(radian) {
  return radian * (180 / Math.PI);
}

/**
@function VVarrtoDBarr
@param  V/V arr
@returns dB arr
@description  This function takes as a parameter as a V/V arr and returns a dB arr
*/
export function VVarrtoDBarr(vvArr) {
  var vvArray = [];
  var dbArray = new Array();

  if (vvArr) {
    vvArray = vvArr; // putting the values of input vvArr to a new array vvArray.
    var len = vvArray.length;
    for (var i = 0; i < len; i++) {
      dbArray[i] = this.VVtoDB(vvArray[i]);
    }
  }

  return dbArray;
}

/**
@function dBtoVV
@param  db point
@returns V/V point
@description  This function takes as a parameter as a DB and returns a V/V point
*/
export function dBtoVV(db) {
  var x = db / 20;
  var vv = Math.pow(10, x);

  return vv;
}

/**
@function VVtoDB
@param  V/V point
@returns dB point
@description  This function takes as a parameter as a V/V and returns a dB point
*/
export function VVtoDB(vv) {
  var log10vv = MathUtils.logBaseTen(vv);
  var db = 20 * log10vv;

  return db;
}

/**
@function groupDelay
@param PhaseArray (in radians)
@param FrequencyArray (in Hz)
@returns [newFrequencyAxis,groupDelay] (x,y respectfully)
@description This function loops through negatedPhaseArray and for each point (except the first one)
gets the frequency difference between the 1st frequency point and previous frequency point, gets the
phase difference between the first phase point and previous phase point,
gets the group delay point by dividing the phase difference/ frequency difference,
gets the new FrequencyAxis by getting the sqrt of the first point frequencyArray parameter and the previous frequencyArray point.
Utilizes the joinArrays function to merge the newFrequencyAxis array with the groupDelayArray.
*/
export function groupDelay(phaseArray, frequencyArray) {
  var frequencyDifference, phaseDifference;
  var groupDelayArray = [];
  var newFrequencyAxis = [];
  var negatedPhaseArray = negatePhase(phaseArray);

  //convert array from Hz to rad/s
  var frequencyRadPerSecondArray = hzToRadPerSecond(frequencyArray);

  //loop through negatedPhaseArray
  for (var i = 1; i < negatedPhaseArray.length; i++) {
    //calculate frequencyDifference
    frequencyDifference = frequencyRadPerSecondArray[i] - frequencyRadPerSecondArray[i - 1];

    //calculate phaseDifference
    phaseDifference = negatedPhaseArray[i] - negatedPhaseArray[i - 1];

    //calculate groupDelay
    groupDelayArray.push(phaseDifference / frequencyDifference);

    //use original frequencyArray to calculate newFrequencyAxis
    newFrequencyAxis.push(Math.sqrt(frequencyArray[i] * frequencyArray[i - 1]));
  }

  return { groupDelayArray, newFrequencyAxis };
}

/**
@function phaseDelay
@param phaseArray
@param frequencyArray
@returns result of negatedPhaseArray/frequency(radians/sec)
@description This function converts frequency HZ to rad/s, calls negatePhaseArray, and divides negatedPhaseArray by the frequency result
*/
export function phaseDelay(phaseArray, frequencyArray) {
  var radPerS = [],
    result = [];

  //convert frequencyArray convert from Hz to rad/s
  radPerS = hzToRadPerSecond(frequencyArray);
  //negate Phase Array
  var negatedPhaseArray = negatePhase(phaseArray);
  //divide negatedPhase array by frequency array
  for (var m = 0; m < radPerS.length; m++) {
    result.push(negatedPhaseArray[m] / radPerS[m]);
  }

  return result;
}
